"use client";

import { ActivityDisplayPreview } from "./previews";

type DayRetreatsDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function DayRetreatsDisplay({
  data,
  participants,
}: DayRetreatsDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="day-retreats"
      data={data}
      participants={participants}
    />
  );
}
